import type { CSSProperties } from "react";
import styled from "styled-components";
import type { DefaultTheme } from "styled-components";

export const getOnPremiseTextFieldContainerStyle = (theme: DefaultTheme): CSSProperties => ({
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
});

export const RadioOptionsList = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.large,
    width: "100%",
    flexShrink: 0,
}));

export const DeliverOptionGroup = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    width: "100%",
}));

export const RadioOptionSurface = styled.div({
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
});

export const InfoWrapper = styled.div(({ theme }) => ({
    flex: 1,
    marginLeft: `${theme.spacing.x14}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxxSmall,
    minWidth: 0,
    padding: `${theme.spacing.xxSmall} 0`,
}));

export const Wrapper = styled.div(({ theme }) => ({
    ".custom-checkbox": {
        top: 0,
        paddingTop: theme.spacing.xxSmall,
    },
}));

export const ScreenSeatRow = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: theme.spacing.small,
    width: "100%",
    boxSizing: "border-box",
}));

export const FieldGrow = styled.div({
    flex: "1 1 0",
    minWidth: 0,
});
